export default function SecurityGroupsFilterDirective() {
  return {
    restrict: 'E',
    template: require('./security-groups-filter.component.html'),
    scope: {
      filters: '='
    },
    controller: SecurityGroupsFilterController
  };


  function SecurityGroupsFilterController(
    $rootScope, $scope, securityGroupsService) {
    'ngInject';
    var currentUser = $rootScope.currentUser;
    $scope.securityGroups = [];
    $scope.showGroups = false;

    function getSecurityGroups() {
      if (currentUser.account.securityMode === 'Open') {
        $scope.securityGroups = [];
        return;
      }
      if (currentUser.securityMode !== 'Open') {
        $scope.securityGroups = currentUser.groups.data;
        if ($scope.securityGroups.length > 1) {
          $scope.showGroups = true;
        }
      } else {
        securityGroupsService.getAllSecurityGroups().then(function (response) {
          $scope.securityGroups = response.data.data;
          if ($scope.securityGroups.length > 0) {
            $scope.showGroups = true;
          }
        }, function (error) {
          $scope.securityGroups = [];
        });
      }

    }

    getSecurityGroups();
  }
}